import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */
import VueTimepicker from "vue2-timepicker";
import AutocompleteObject from "../components/Shared/AutocompleteObject";

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'driver'],

    data() {
        return {
            title: '',
            isLoading: false,
            hasError: '',
            choosedTime: {HH: '08' , mm: '00'},
        };
    },
    components: {  VueTimepicker },
    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.title = this.driver.firstName;
                try{
                    var time = this.driver.startTime.split(":");
                    this.choosedTime = {HH: time[0] , mm: time[1]};
                }catch (e){
                    this.choosedTime = {HH: '08' , mm: '00'};
                }

            }
        },
        choosedTime: function (val, oldVal){
            this.hasError = ''
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeCourierChangeStart')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successCourierChangeStart')
        },

        changeTime: changeTime,
        checkNullString: checkNullString,
        reset: reset,
    }
}

function changeTime() {
    var _self = this;
    if(this.choosedTime.HH === "" || this.choosedTime.mm === ""){
        this.hasError = 'Izaberite  početak smene';
        return;
    }

    var newModel = {
        startTime: this.choosedTime.HH + ":" + this.choosedTime.mm
    }

    AdminApiService.changeCourierStartTime(this.driver.id, newModel)
        .then((response) => {

            // swal('Uspešno', 'Uspešno kreiran raspored', 'success')
            _self.reset();
            _self.successUpdate();
            this.isDisabledAddButton = false;

        })
        .catch((error) => {
            _self.hasError = 'Greska';

        })

}

function reset() {
    this.choosedTime = {HH: '08' , mm: '00'};
    this.hasError = ''
}


function checkNullString(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/modals/ChangeCourierStartShift.js